<script setup>
import { onMounted, computed, watch, ref } from 'vue';
import { useProjeto } from '@/modules/projeto/composables/useProjeto';

const { rubricasDetalhes, carregarRubricasDetalhesPorCodigo } = useProjeto();

const props = defineProps({
    projetoId: String,
    rubricaFinanceiraCodigo: {
        type: String,
        default: null
    },
    erro: {
        type: String,
        default: null
    },
    modelValue: {
        type: Number,
        default: null
    },
})

const emit = defineEmits(['update:modelValue', 'change', 'reset']);

const detalhamentoSelecionado = ref();

const options = computed(() => {
    return rubricasDetalhes.value.detalhes
});

watch(
    () => [props.projetoId, props.rubricaFinanceiraCodigo],
    async ([newProjetoId, newRubricaFinanceiraCodigo], [, oldRubricaFinanceiraCodigo]) => {
        if (newProjetoId && newRubricaFinanceiraCodigo) {
            await carregarRubricasDetalhesPorCodigo(newProjetoId, newRubricaFinanceiraCodigo);

            // Limpar seleção se a rubrica financeira mudou
            if (oldRubricaFinanceiraCodigo && newRubricaFinanceiraCodigo !== oldRubricaFinanceiraCodigo) {
                emit('reset');
            }

            if (props.modelValue) {
                detalhamentoSelecionado.value = options.value.find(detalhe => detalhe.id === props.modelValue) || null;
            }

        } else {
            emit('reset');
            rubricasDetalhes.value.detalhes = [];
        }
    }
);

watch(
    () => props.modelValue,
    async (newValue) => {
        if (newValue) {
            // Garantir que os detalhes estejam carregados
            if (props.projetoId && props.rubricaFinanceiraCodigo) {
                await carregarRubricasDetalhesPorCodigo(props.projetoId, props.rubricaFinanceiraCodigo);
            }

            if(options.value){
                detalhamentoSelecionado.value = options.value.find(detalhe => detalhe.id === newValue) || null;
            }
        } else {
            emit('reset');
            detalhamentoSelecionado.value = null;
        }
    },
    { immediate: true }
);

watch(
    () => detalhamentoSelecionado.value,
    (newValue) => {
        if (newValue) {
            emit('update:modelValue', newValue.id);
            emit('change', newValue);
        }

        if(!newValue){
            detalhamentoSelecionado.value = null;
            emit('reset');
            emit('update:modelValue', null);
        }
    }
);

onMounted(async () => {
    // Aguardar carregamento inicial das rubricas
    if (props.projetoId && props.rubricaFinanceiraCodigo) {
        await carregarRubricasDetalhesPorCodigo(props.projetoId, props.rubricaFinanceiraCodigo);
    }
});
</script>

<template>
    <div class="field mb-2 col-12">
        <SmallTitle titulo="Detalhamento de Rubrica" :obrigatorio="true" />
        <Dropdown :options="options" v-model="detalhamentoSelecionado" optionLabel="descricao"
            emptyFilterMessage="Nenhum detalhe encontrado" :class="{ 'p-invalid': props.erro }"
            placeholder="Selecione o detalhamento" :showClear="true">
        </Dropdown>
        <SmallError v-if="props.erro" :error="props.erro" />
    </div>
</template>